@if (artifact.url) {
  <a class="btn btn-sm btn-primary software-item-button" [ngClass]="{'btn-primary': hierachyLevel === ButtonHierarchyLevel.FIRST, 'btn-link': hierachyLevel === ButtonHierarchyLevel.SECOND}"
    [href]="artifact.url"
    target="_blank"
    download
  >{{ 'download' | translate }}</a>
}
@if (!artifact.url) {
  <button
    class="btn btn-danger software-item-button"
    disabled>{{ 'download' | translate }}
  </button>
}
